module.exports = __webpack_public_path__ + "img/3.04bd7011.jpg";